import { useMutation } from 'react-query';

import { wellnub } from 'network/wellnub.api';

const requestValidateResetPasswordToken = async payload => {
  const { data } = await wellnub.post('/v1/auth/validateResetToken', payload);
  return data;
};

const requestSetNewPassword = async payload => {
  const { data } = await wellnub.post('/v1/auth/resetPassword', payload);
  return data;
};

export const useValidateResetPasswordToken = () =>
  useMutation(requestValidateResetPasswordToken);

export const useSetNewPassword = () => useMutation(requestSetNewPassword);
